export default function SkipLink() {
  return (
    <a className="skip-link" href="#conteudo-principal">
      Pular para o conteúdo principal
    </a>
  );
}
